<h1 mat-dialog-title>Confirmation</h1>
<div mat-dialog-content>
    <p>You are about to copy selected row {{columnName}} to a total of {{totalSize}} records. Proceed to Yes or Preview to load all the records? </p>
</div>
<div mat-dialog-actions>
    <button mat-button (click)="proceed()">Yes</button>
    <button mat-button (click)="preview()">Preview</button>
    <button mat-button (click)="onClose()" cdkFocusInitial>No</button>
</div>